import { render, staticRenderFns } from "./FabricInventory.vue?vue&type=template&id=4e120920"
import script from "./FabricInventory.vue?vue&type=script&lang=js"
export * from "./FabricInventory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports